import * as XLSX from 'xlsx';

export const downloadCsv = (e, fields, resources, name = "") => {
  e.preventDefault();

  let fileName;

  switch (name) {
    case "disbursements":
      fileName = "Desembolso"
      break;
    case "physical_financials":
      fileName = "Físico Financeiro"
      break;
    case "paid_values":
      fileName = "Pago"
      break;
    case "to_pay_values":
      fileName = "A Pagar"
      break;
    case "advancements":
      fileName = "Ajustes de desembolso"
      break;
    case "ampli_disbursements":
      fileName = "Desembolso (Ampli)"
      break;
    case "all":
      fileName = "Relatório Geral"
      break;
    default:
      fileName = name
      break;
  }

  const worksheet = XLSX.utils.json_to_sheet(
    resources.map(resource => {
      const row = {};
      fields.forEach(field => {
        if (field.key === "building_unit_name") {
          row[field.label] = resource.building_unit_name ?? resource.description ?? '';
        } else {
          row[field.label] = resource[field.key] ?? '';
        }
      });
      return row;
    })
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', fileName + " " + new Date().toLocaleString().replace(/[/,:]/g, '-') + '.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Função auxiliar para converter string para array buffer
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
}
